
const tools = {
    muted:false
}

export default tools